import { useEffect } from "react";

export function useMountDebug(label: string) {
  useEffect(() => {
    console.info(`[mount] ${label}`, { timestamp: new Date().toISOString() });
    return () => {
      console.info(`[unmount] ${label}`, { timestamp: new Date().toISOString() });
    };
  }, [label]);
}
